import { useEffect, RefObject } from 'react';

type Event = MouseEvent | TouchEvent;

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  refOrRefs: RefObject<T | null> | Array<RefObject<T | null>>,
  handler: (event: Event) => void,
) => {
  useEffect(() => {
    const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];

    const listener = (event: Event) => {
      const target = event.target as Node | null;

      const clickedInside = refs.some((ref) => {
        const el = ref.current;

        return el?.contains(target);
      });

      if (clickedInside) return;

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refOrRefs, handler]);
};

export default useOnClickOutside;
